// components/Footer.js
import React, { useState } from 'react'
import Imprint from '../general/Imprint'
import Privacy from '../general/Privacy'
import TermsConditions from '../general/TermsConditions'
import { useTranslation } from 'react-i18next'
import '../assets/css/Footer.css'

function Footer() {
  const { t } = useTranslation()
  const [modalContent, setModalContent] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const openModal = (content) => {
    setModalContent(content)
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setModalContent(null)
    setIsModalOpen(false)
  }

  return (
    <>
      <footer className="footer">
        <div className="footer-content">
	       <li className="language-selector-wrapper">
              <div id="language-selector-container" className="language-selector-container" />
            </li>
	  <br></br>
          <p>&copy; {new Date().getFullYear()} R2D2+. {t('footer.copyright')}</p>
          <div className="footer-links">
  <a href="#" className="footer-link" onClick={(e) => { e.preventDefault(); openModal(<Privacy />); }}>
    {t('footer.privacy_policy')}
  </a>
  <a href="#" className="footer-link" onClick={(e) => { e.preventDefault(); openModal(<TermsConditions />); }}>
    {t('footer.terms_of_service')}
  </a>
  <a href="#" className="footer-link" onClick={(e) => { e.preventDefault(); openModal(<Imprint />); }}>
    {t('imprint')}
  </a>
</div>
        </div>
      </footer>
      {isModalOpen && (
        <div id="footer-modal" className="footer-modal">
          <div className="footer-modal-overlay" onClick={closeModal} />
          <div className="footer-modal-content">
            <button className="footer-modal-close" onClick={closeModal}>×</button>
            <div className="footer-modal-body">{modalContent}</div>
          </div>
        </div>
      )}
    </>
  )
}

export default Footer